import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
  init() {
    console.log('single product');

    new Swiper('.swiperSingleProduct', {
		modules: [Pagination],
		slideToClickedSlide: false,
		pagination: {
			el: '.swiper-pagination',
		},
		slidesPerView: 1,
		loop: true,
	});

	const accordion = document.querySelector('#single-prodotto-accordion');
	const accordionContent = document.querySelector('#single-prodotto-accordion-content');


	accordion.addEventListener('click', () => {
		const icon = accordion.querySelector('img');
		icon.classList.toggle('rotate-180');
		
		accordionContent.classList.toggle('open');
		
	});

	new Swiper('.swiperSingleProdottoRelated', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 3,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},

		spaceBetween: 30,
		direction: 'horizontal',
		loop: false,
	});

	new Swiper('.swiperCosaDistingue', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 1,
		loop: true,
	});


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
